import { render } from "./miniuser.module.vue?vue&type=template&id=4dfe83da"
import script from "./miniuser.module.vue?vue&type=script&lang=js"
export * from "./miniuser.module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__